'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemSaveIcon = require('./ItemSaveIcon.scss');

var _ItemSaveIcon2 = _interopRequireDefault(_ItemSaveIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSaveIcon = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ItemSaveIcon, _Component);

    function ItemSaveIcon() {
        (0, _classCallCheck3.default)(this, ItemSaveIcon);
        return (0, _possibleConstructorReturn3.default)(this, (ItemSaveIcon.__proto__ || (0, _getPrototypeOf2.default)(ItemSaveIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(ItemSaveIcon, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'iconClassName', 'saved']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                iconClassName = _props.iconClassName,
                save = _props.save,
                saved = _props.saved;

            var icon = saved ? ['fas', 'heart'] : ['far', 'heart'];
            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ItemSaveIcon2.default['save-container']]).join(' ');
            var iconClasses = [].concat((0, _toConsumableArray3.default)(iconClassName.split(' ')), [_ItemSaveIcon2.default.save]).join(' ');
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: iconClasses,
                icon: icon,
                onClick: save
            }));
        }
    }]);
    return ItemSaveIcon;
}(_react.Component), _class.defaultProps = {
    className: '',
    iconClassName: '',
    saved: false
}, _temp);
exports.default = ItemSaveIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemSave/ItemSaveIcon.js
// module id = MKYO
// module chunks = 57